import { requiredValidator } from '../../required'

export const FormikRequired = value => {
  let errorMessage
  if (!requiredValidator(value)) errorMessage = 'Obavezno polje'
  return errorMessage
}
